export const VIEW_ONLY_USERS = [
  'huypq@book.appixi.net'
];

export const PAYMENT_ADMIN_EMAILS = [
  'report@song.appixi.net',
];

export const getCurrentUserEmail = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return user?.email || null;
  } catch {
    return null;
  }
};

export const canViewPaymentAdmin = () => {
  const email = getCurrentUserEmail();
  if (!email) return false;
  return PAYMENT_ADMIN_EMAILS.includes(email.trim().toLowerCase());
};

export const isViewOnlyUser = () => {
  const currentEmail = getCurrentUserEmail();
  return currentEmail && VIEW_ONLY_USERS.includes(currentEmail);
};

export const hasEditPermission = () => {
  return !isViewOnlyUser();
};

export const hasDeletePermission = () => {
  return !isViewOnlyUser();
};
